module.exports = __webpack_public_path__ + "media/images/category/feature/echigo/og-echigo-d03b5d8b6b25a0bd8e4bc3e3c0fb56b9.png";